import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';
export type AddEmojiDTO = {
  data: {
    emoji: string;
    unified: string;
    petId: number | undefined;
  };
};

export type requestDTO = {
  data: {
    id?: number | string;
    name: string;
    breed: string;
    gender: string;
    weight: string;
    dateOfBirth: string;
    notes: string;
    petParentId?: string;
    petsImageUrl?: string;
    petType?: string;
    petColor?: string;
    petAge?: string;
  };
};

export const addPet = ({ data }: requestDTO): Promise<requestDTO> => {
  return axios.post(`/business/update-pet`, data);
};
export const addEmoji = ({ data }: AddEmojiDTO) => {
  return axios.post(`/business/add-emoji`, data);
};

type UseAddEmojiOptions = {
  config?: MutationConfig<typeof addEmoji>;
};

export const useAddEmoji = ({ config }: UseAddEmojiOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Emoji added successfully',
      });
    },
    ...config,
    mutationFn: addEmoji,
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof addPet>;
};

export const useAddPet = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet Updated successfully',
      });
    },
    ...config,
    mutationFn: addPet,
  });
};
